export const generateUrls = () => ({
  loginSessionsIndexUrl: '#/systemManager/loginSessions',
})

function useLoginSession() {
  return {
    urls: generateUrls(),
  }
}

export default useLoginSession
